// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ec-3";
export var flatBottomCorners = "_ec-5";
export var productImage = "_ec-0";
export var quantityContainer = "_ec-2";
export var quantityHeader = "_ec-6";
export var tooltip = "_ec-1";
export var wrapAndEllipsesOverflow = "_ec-4";